import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Home from './pages/home';
import Error404 from './pages/error404';

const Path = () => {
    return ( 
        <>
        <BrowserRouter>
            <Routes>      
                <Route path='/' element={<Home />} />
                <Route path='*' element={<Error404 />} />
            </Routes>
        </BrowserRouter>
        </>
     );
}
 
export default Path;